(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.manageUsers', {
                url: '/manage-users',
                templateUrl: 'app/components/manageUsers/manageUsers.view.html',
                controller: 'ManageUsersController',
                controllerAs: 'vm'
            });
    }
})();
